<script>
/**
 * Reports-View-Report1 component
 */
import axios from '@/axios'
import { apiUrl } from '@/state/helpers'

import priceMixin from '@/mixins/priceMixin'
import tidMixin from '@/mixins/tidMixin'

export default {
    mixins: [priceMixin, tidMixin],

    data() {
        return {
            s_date_report: -1,
            e_date_report: -1,
            selected_tids: [],

            reportData:[],
            
            fields: [
                {
                    key: "name",
                    label: this.$t("label.report_p_m_table_metod"),
                    sortable: false,
                },
                {
                    key: "sales",
                    label: this.$t("label.report_p_m_table_h_sales"),
                    sortable: false,
                },
                {
                    key: "refunds",
                    label: this.$t("label.report_p_m_table_h_refunds"),
                    sortable: false,
                },
                {
                    key: "total",
                    label: this.$t("label.report_p_m_table_h_total"),
                    sortable: false,
                }
            ],

            pay_metod: [
                this.$t("label.report_p_m_0"),
                this.$t("label.report_p_m_1"),
                this.$t("label.report_p_m_2"),
                this.$t("label.report_p_m_3"),
                this.$t("label.report_p_m_4"),
                this.$t("label.report_p_m_5"),
                this.$t("label.report_p_m_6"),
                this.$t("label.report_total"),
            ]
        }
    },

    mounted() {
        this.selected_tids = this.setSelectedTids(this.$store.state.reports.selectedTids.tids);
        this.report_type = this.$store.state.reports.reportType.repType;
        this.setReportTime();

        axios.defaults.headers.common = {
            Authorization: `Bearer ${this.$store.state.authapi.user.token}`,
        }

        this.fetchMerchantReport();
    },

    computed: {
        sortedReport(){
            return this.reportData.slice().sort(function(a, b) {
                return a.index - b.index;
            });
        }
    },

    methods: { 
        setReportTime(){
            if(this.$store.state.reports.reportDays.startDay == -1){
                this.s_date_report = -1;
            }else{
                this.s_date_report = Math.floor(new Date(this.$store.state.reports.reportDays.startDay).getTime() / 1000);
            }

            if(this.$store.state.reports.reportDays.endDay == -1){
                this.e_date_report = -1;
            }else{
                this.e_date_report = Math.floor(new Date(this.$store.state.reports.reportDays.endDay).getTime() / 1000);
            }
            this.setCallingUrl();
        },

        setCallingUrl(){
            this.calling_url = `${apiUrl}/reports/report2`;
            this.calling_params = {
                "from": this.s_date_report,
                "to": this.e_date_report,
                "tids": this.selected_tids,
                "limit": 10,
            };
        },

        async fetchMerchantReport(){
            this.isBusy = !this.isBusy;
            this.reportData = ['0', '0'];
        await axios
            .post(this.calling_url, this.calling_params)
            .then((response) => {
                var res = JSON.parse(JSON.stringify(response.data))
                this.reportData = [];
                let sles_sum = 0;
                let refunds_sum = 0;
                let total_sum = 0;
                //console.log(`payment_methods`, res);
                Object.entries(res).forEach(([key, value]) => {
                    let name_index = key.split(":")[0];
                    let total = value.sales - value.refunds;
                    
                    sles_sum += value.sales;
                    refunds_sum += value.refunds;
                    total_sum += total;
                    //console.log(this.pay_metod[name_index]);
                    this.reportData.push({
                        index:name_index, 
                        name:this.pay_metod[name_index], 
                        sales:this.formatNumberDispaly(value.sales), 
                        refunds:this.formatNumberDispaly(value.refunds), 
                        total:this.formatNumberDispaly(total)
                    });
                });
                //totali
                this.reportData.push({
                        index:7, 
                        name:this.pay_metod[7], 
                        sales:this.formatNumberDispaly(sles_sum), 
                        refunds:this.formatNumberDispaly(refunds_sum), 
                        total:this.formatNumberDispaly(total_sum)
                    });

                this.reportData = this.sortedReport;
                console.log(this.reportData);
                this.isBusy = !this.isBusy;
            }).catch((error) => {
                this.isBusy = !this.isBusy;

            // console.log("error", error);
            // console.log(error.response);

            if (error.response != undefined && error.response.status === 401) {
                this.$store.dispatch('authapi/logoutauthapi')
                this.$router.push('/login')
            } else if (
                error.response != undefined &&
                error.response.status === 400
            ) {
                // toastMixin.methods.displayToastAlert(error.response.data, "error");
            } else {
                // toastMixin.methods.displayToastAlert(
                //   this.$t("alerts.something_went_wrong"),
                //   "error"
                // );
            }
            })
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
    }
}
</script>
<template>
    <div class="bg-white mb-2 p-4">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                  <div class="table-responsive mb-0">
                    <b-table
                      class="datatables"
                      :items="reportData"
                      :fields="fields"
                      responsive="sm"
                      :busy="isBusy"
                      @head-clicked="headClicked"
                    >
                        <template #table-busy>
                          <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong class="pl-2">&nbsp;{{ $t("label.loading") }}</strong>
                          </div>
                        </template>
                        <template #top-row v-if="reportData.length === 0">
                            <td
                                :colspan="fields.length"
                                class="text-center"
                            >
                                <div class="text-center my-2">
                                <h3 class="text-danger pl-2 align-middle">{{ $t("label.report_no_results") }}</h3>
                                </div>
                          </td>
                        </template>
                    </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>